<template>
  <Teleport to="body">
  <div class="payroll-setup-modals">
  <div class="modal fade payroll-setup-modal" id="salaryStructureManagementModal" tabindex="-1" aria-labelledby="salaryStructureManagementModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="salaryStructureManagementModalLabel">Salary Structure Management</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeModalFromEvent($event)" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="loading" class="text-center py-4">
            <div class="spinner-border text-primary me-2" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">Loading salary structures...</p>
          </div>

          <div v-else>
            <!-- Controls section -->
            <div class="d-flex justify-content-between mb-3">
              <h6 class="mb-0 mt-2">Manage Salary Structures</h6>
              <button @click="showAddModal" class="btn btn-sm btn-primary">
                <i class="mdi mdi-plus me-1"></i> Add Salary Structure
              </button>
            </div>

            <!-- Salary Structure Cards -->
            <div class="row mb-4">
              <div v-if="salaryStructures.length === 0" class="col-12 text-center py-4">
                <i class="mdi mdi-file-tree-outline text-muted" style="font-size: 48px;"></i>
                <p class="mt-2">No salary structures found</p>
              </div>
              <div v-for="structure in salaryStructures" :key="structure.id" class="col-lg-6 col-xl-4 mb-3">
                <div class="card h-100">

                  <div class="card-header d-flex justify-content-between align-items-center"
                       :class="{'bg-primary': structure.is_active === '1', 'bg-light': structure.is_active !== '1'}">

                    <h6 class="mb-0" :class="{'text-white': structure.is_active === '1'}">
                      {{ structure.structure_name }}
                    </h6>

                    <div class="dropdown">
                      <button class="btn btn-sm btn-icon" type="button" data-bs-toggle="dropdown">
                        <i class="mdi mdi-dots-vertical"
                           :class="structure.is_active === '1' ? 'text-white' : 'text-dark'"></i>
                      </button>

                      <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                          <a class="dropdown-item" href="javascript:void(0);" @click="editStructure(structure)">
                            <i class="mdi mdi-pencil me-1"></i> Edit
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item" href="javascript:void(0);" @click="viewLinkedGrades(structure)">
                            <i class="mdi mdi-eye me-1"></i> View Linked Grades
                          </a>
                        </li>
                        <li v-if="!structure.is_active">
                          <a class="dropdown-item" href="javascript:void(0);" @click="setActiveStructure(structure.id)">
                            <i class="mdi mdi-check-circle me-1"></i> Set as Active
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item text-danger" href="javascript:void(0);" @click="deleteStructure(structure.id)">
                            <i class="mdi mdi-trash-can me-1"></i> Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="mb-3">
                      <small class="text-muted d-block">Status</small>
                      <span class="badge" :class="structure.is_active === '1' ? 'bg-success' : 'bg-secondary'">
                        {{ structure.is_active === '1' ? 'Active' : 'Inactive' }}</span>

                    </div>
                    <div class="mb-3">
                      <small class="text-muted d-block">Created By</small>
                      <span>{{ structure.created_by }}</span>
                    </div>
                    <div class="mb-3">
                      <small class="text-muted d-block">Created On</small>
                      <span>{{ formatDate(structure.created_at) }}</span>
                    </div>
                    <div>
                      <small class="text-muted d-block">Description</small>
                      <p class="mb-0">{{ structure.description || 'No description available' }}</p>
                    </div>
                  </div>
                  <div class="card-footer bg-light">
                    <div class="d-flex justify-content-between align-items-center">
                      <small class="text-muted">
                        <span class="badge bg-info">{{ structure.grade_count || 0 }}</span> Pay Grades
                      </small>
                      <button @click="manageSalaryComponents(structure)" class="btn btn-sm btn-outline-primary">
                        <i class="mdi mdi-sitemap me-1"></i> Components
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModalFromEvent($event)">Close</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Add/Edit Salary Structure Modal -->
  <div class="modal fade payroll-setup-modal" id="salaryStructureFormModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ isEditing ? 'Edit Salary Structure' : 'Add Salary Structure' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeModalFromEvent($event)" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="saveStructure">
            <div class="mb-3">
              <label for="structureName" class="form-label">Structure Name <span class="text-danger">*</span></label>
              <input
                  type="text"
                  class="form-control"
                  id="structureName"
                  v-model="structureForm.structure_name"
                  required
                  placeholder="e.g. Management Structure, Staff Structure"
              >
            </div>

            <div class="mb-3">
              <div class="form-check">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="isActive"
                    v-model="isActiveBoolean"
                >
                <label class="form-check-label" for="isActive">
                  Active Structure
                </label>
              </div>
              <small class="text-muted">If checked, this will be set as an active salary structure</small>
            </div>

            <div class="mb-3">
              <label for="description" class="form-label">Description</label>
              <textarea
                  class="form-control"
                  id="description"
                  v-model="structureForm.description"
                  rows="3"
                  placeholder="Describe the purpose and scope of this salary structure"
              ></textarea>
            </div>

            <div class="mb-3">
              <label class="form-label">Departments</label>
              <div class="card">
                <div class="card-body p-2">
                  <div class="form-check" v-for="department in departments" :key="department.id">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        :id="`dept-${department.id}`"
                        :value="department.id"
                        v-model="structureForm.departments"
                    >
                    <label class="form-check-label" :for="`dept-${department.id}`">
                      {{ department.departmentName }}
                    </label>
                  </div>
                  <div v-if="!departments.length" class="text-center text-muted py-2">
                    No departments available
                  </div>
                </div>
              </div>
              <small class="text-muted">Select departments where this salary structure applies</small>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModalFromEvent($event)">Cancel</button>
          <button
              type="button"
              class="btn btn-primary"
              @click="saveStructure"
              :disabled="!isFormValid || submitLoading"
          >
            <span v-if="submitLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {{ isEditing ? 'Update' : 'Save' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Linked Pay Grades Modal -->
  <div class="modal fade payroll-setup-modal" id="linkedGradesModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ currentStructureName }} - Linked Pay Grades</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeModalFromEvent($event)" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="loadingGrades" class="text-center py-4">
            <div class="spinner-border text-primary me-2" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">Loading pay grades...</p>
          </div>
          <div v-else>
            <div class="d-flex justify-content-between mb-3 align-items-center">
              <h6 class="mb-0">Pay Grades</h6>
              <button @click="linkNewGrades" class="btn btn-sm btn-primary">
                <i class="mdi mdi-link-plus me-1"></i> Link Pay Grades
              </button>
            </div>

            <!-- Linked Grades Table -->
            <div class="table-responsive">
              <table class="table table-sm table-hover table-bordered">
                <thead class="table-light">
                <tr>
                  <th>Grade Name</th>
                  <th>Min Salary</th>
                  <th>Max Salary</th>
                  <th>Midpoint</th>
                  <th class="text-center">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="linkedGrades.length === 0">
                  <td colspan="5" class="text-center py-3">No pay grades linked to this structure</td>
                </tr>
                <tr v-for="grade in linkedGrades" :key="grade.id">
                  <td>{{ grade.grade_name }}</td>
                  <td>{{ formatCurrency(grade.min_salary) }}</td>
                  <td>{{ formatCurrency(grade.max_salary) }}</td>
                  <td>{{ formatCurrency(grade.midpoint_salary) }}</td>
                  <td class="text-center">
                    <button @click="unlinkGrade(grade.id)" class="btn btn-sm btn-danger">
                      <i class="mdi mdi-link-off"></i> Unlink
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModalFromEvent($event)">Close</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Link New Pay Grades Modal -->
  <div class="modal fade payroll-setup-modal" id="linkGradesModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Link Pay Grades to {{ currentStructureName }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeModalFromEvent($event)" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="loadingAvailableGrades" class="text-center py-4">
            <div class="spinner-border text-primary me-2" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">Loading available pay grades...</p>
          </div>
          <div v-else>
            <div class="mb-3">
              <input
                  type="text"
                  class="form-control"
                  placeholder="Search pay grades..."
                  v-model="gradeSearchKeyword"
                  @input="searchGrades"
              >
            </div>

            <!-- Available Grades Table -->
            <div class="table-responsive">
              <table class="table table-sm table-hover table-bordered">
                <thead class="table-light">
                <tr>
                  <th style="width: 40px;" class="text-center">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="selectAllGrades"
                        @change="toggleSelectAllGrades"
                    >
                  </th>
                  <th>Grade Name</th>
                  <th>Min Salary</th>
                  <th>Max Salary</th>
                  <th>Midpoint</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="filteredAvailableGrades.length === 0">
                  <td colspan="5" class="text-center py-3">No available pay grades found</td>
                </tr>
                <tr v-for="grade in filteredAvailableGrades" :key="grade.id">
                  <td class="text-center">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        :value="grade.id"
                        v-model="selectedGradesToLink"
                    >
                  </td>
                  <td>{{ grade.grade_name }}</td>
                  <td>{{ formatCurrency(grade.min_salary) }}</td>
                  <td>{{ formatCurrency(grade.max_salary) }}</td>
                  <td>{{ formatCurrency(grade.midpoint_salary) }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModalFromEvent($event)">Cancel</button>
          <button
              type="button"
              class="btn btn-primary"
              @click="linkSelectedGrades"
              :disabled="!selectedGradesToLink.length || submitLoading"
          >
            <span v-if="submitLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Link Selected Grades
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Salary Components Modal -->
  <div class="modal fade payroll-setup-modal" id="salaryComponentsModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ currentStructureName }} - Salary Components</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeModalFromEvent($event)" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="loadingComponents" class="text-center py-4">
            <div class="spinner-border text-primary me-2" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">Loading salary components...</p>
          </div>
          <div v-else>
            <ul class="nav nav-tabs" id="componentsTabs" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="allowances-tab" data-bs-toggle="tab" data-bs-target="#allowances" type="button" role="tab">
                  Allowances
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="deductions-tab" data-bs-toggle="tab" data-bs-target="#deductions" type="button" role="tab">
                  Deductions
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="benefits-tab" data-bs-toggle="tab" data-bs-target="#benefits" type="button" role="tab">
                  Benefits
                </button>
              </li>
            </ul>
            <div class="tab-content pt-3" id="componentsTabContent">
              <!-- Allowances Tab -->
              <div class="tab-pane fade show active" id="allowances" role="tabpanel">
                <div class="d-flex justify-content-between mb-3">
                  <h6 class="mb-0">Default Allowances</h6>
                  <button @click="addAllowanceToStructure" class="btn btn-sm btn-primary">
                    <i class="mdi mdi-plus me-1"></i> Add Allowance
                  </button>
                </div>

                <div class="table-responsive">
                  <table class="table table-sm table-hover">
                    <thead class="table-light">
                    <tr>
                      <th>Allowance</th>
                      <th>Type</th>
                      <th>Value</th>
                      <th>Taxable</th>
                      <th class="text-center">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="structureAllowances.length === 0">
                      <td colspan="5" class="text-center py-3">No default allowances configured</td>
                    </tr>
                    <tr v-for="allowance in structureAllowances" :key="allowance.id">
                      <td>{{ allowance.allowance_name }}</td>

                        <td>{{ allowance.is_percentage === '1' ? 'Percentage' : 'Fixed' }}</td>

                      <td>
                        {{ allowance.is_percentage === '1'
                          ? allowance.percentage + '%'
                          : formatCurrency(allowance.amount) }}
                      </td>


                      <td>
                          <span class="badge" :class="allowance.is_taxable === '1' ? 'bg-success' : 'bg-warning'">
  {{ allowance.is_taxable === '1' ? 'Yes' : 'No' }}
</span>

                      </td>
                      <td class="text-center">
                        <button @click="removeComponentFromStructure(allowance.id, 'allowance')" class="btn btn-sm btn-danger">
                          <i class="mdi mdi-delete"></i>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Deductions Tab -->
              <div class="tab-pane fade" id="deductions" role="tabpanel">
                <div class="d-flex justify-content-between mb-3">
                  <h6 class="mb-0">Default Deductions</h6>
                  <button @click="addDeductionToStructure" class="btn btn-sm btn-primary">
                    <i class="mdi mdi-plus me-1"></i> Add Deduction
                  </button>
                </div>

                <div class="table-responsive">
                  <table class="table table-sm table-hover">
                    <thead class="table-light">
                    <tr>
                      <th>Deduction</th>
                      <th>Type</th>
                      <th>Value</th>
                      <th>Mandatory</th>
                      <th class="text-center">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="structureDeductions.length === 0">
                      <td colspan="5" class="text-center py-3">No default deductions configured</td>
                    </tr>
                    <tr v-for="deduction in structureDeductions" :key="deduction.id">
                      <td>{{ deduction.deduction_name }}</td>
                      <td>{{ deduction.is_percentage === '1' ? 'Percentage' : 'Fixed' }}</td>

                      <td>
                        {{ deduction.is_percentage === '1'
                          ? deduction.percentage + '%'
                          : formatCurrency(deduction.amount) }}
                      </td>


                      <td>
                         <span class="badge" :class="deduction.is_mandatory === '1' ? 'bg-danger' : 'bg-secondary'">
  {{ deduction.is_mandatory === '1' ? 'Yes' : 'No' }}
</span>

                      </td>

                      <td class="text-center">
                        <button @click="removeComponentFromStructure(deduction.id, 'deduction')" class="btn btn-sm btn-danger">
                          <i class="mdi mdi-delete"></i>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Benefits Tab -->
              <div class="tab-pane fade" id="benefits" role="tabpanel">
                <div class="d-flex justify-content-between mb-3">
                  <h6 class="mb-0">Default Benefits</h6>
                  <div>
                    <button @click="showCreateBenefitModal" class="btn btn-sm btn-outline-primary me-2">
                      <i class="mdi mdi-package-variant-plus me-1"></i> Create Benefit
                    </button>
                    <button @click="addBenefitToStructure" class="btn btn-sm btn-primary">
                      <i class="mdi mdi-plus me-1"></i> Add Benefit
                    </button>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table table-sm table-hover">
                    <thead class="table-light">
                    <tr>
                      <th>Benefit</th>
                      <th>Description</th>
                      <th>Monetary Value</th>
                      <th class="text-center">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="structureBenefits.length === 0">
                      <td colspan="4" class="text-center py-3">No default benefits configured</td>
                    </tr>
                    <tr v-for="benefit in structureBenefits" :key="benefit.id">
                      <td>{{ benefit.benefit_name }}</td>
                      <td>{{ benefit.description || 'N/A' }}</td>
                      <td>{{ benefit.monetary_value ? formatCurrency(benefit.monetary_value) : 'N/A' }}</td>
                      <td class="text-center">
                        <button @click="removeComponentFromStructure(benefit.id, 'benefit')" class="btn btn-sm btn-danger">
                          <i class="mdi mdi-delete"></i>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModalFromEvent($event)">Close</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Add Allowance to Structure Modal -->
  <div class="modal fade payroll-setup-modal" id="addAllowanceModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Allowance to {{ currentStructureName }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeModalFromEvent($event)" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="loadingAllowanceTypes" class="text-center py-4">
            <div class="spinner-border text-primary me-2" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">Loading allowance types...</p>
          </div>
          <div v-else>
            <div class="mb-3">
              <label for="allowanceType" class="form-label">Allowance Type <span class="text-danger">*</span></label>
              <select
                  id="allowanceType"
                  class="form-select"
                  v-model="componentForm.component_id"
                  required
              >
                <option value="">Select Allowance Type</option>
                <option
                    v-for="allowance in availableAllowanceTypes"
                    :key="allowance.id"
                    :value="allowance.id"
                >
                  {{ allowance.allowance_name }}
                </option>
              </select>
            </div>

            <div class="mb-3">
              <div class="form-check">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="isPercentageAllowance"
                    v-model="componentForm.is_percentage"
                >
                <label class="form-check-label" for="isPercentageAllowance">
                  Percentage Based
                </label>
              </div>
            </div>

            <div class="mb-3" v-if="componentForm.is_percentage">
              <label for="percentageValue" class="form-label">Percentage (%) <span class="text-danger">*</span></label>
              <input
                  type="number"
                  class="form-control"
                  id="percentageValue"
                  v-model="componentForm.percentage"
                  min="0"
                  max="100"
                  step="0.01"
                  placeholder="e.g. 15.5"
                  required
              >
            </div>

            <div class="mb-3" v-else>
              <label for="amountValue" class="form-label">Amount <span class="text-danger">*</span></label>
              <input
                  type="number"
                  class="form-control"
                  id="amountValue"
                  v-model="componentForm.amount"
                  min="0"
                  step="0.01"
                  placeholder="e.g. 5000"
                  required
              >
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModalFromEvent($event)">Cancel</button>
          <button
              type="button"
              class="btn btn-primary"
              @click="saveComponentToStructure('allowance')"
              :disabled="!isComponentFormValid || submitLoading"
          >
            <span v-if="submitLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Add Allowance
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Add Deduction to Structure Modal -->
  <div class="modal fade payroll-setup-modal" id="addDeductionModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Deduction to {{ currentStructureName }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeModalFromEvent($event)" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="loadingDeductionTypes" class="text-center py-4">
            <div class="spinner-border text-primary me-2" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">Loading deduction types...</p>
          </div>
          <div v-else>
            <div class="mb-3">
              <label for="deductionType" class="form-label">Deduction Type <span class="text-danger">*</span></label>
              <select
                  id="deductionType"
                  class="form-select"
                  v-model="componentForm.component_id"
                  required
              >
                <option value="">Select Deduction Type</option>
                <option
                    v-for="deduction in availableDeductionTypes"
                    :key="deduction.id"
                    :value="deduction.id"
                >
                  {{ deduction.deduction_name }}
                </option>
              </select>
            </div>

            <div class="mb-3">
              <div class="form-check">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="isPercentageDeduction"
                    v-model="componentForm.is_percentage"
                >
                <label class="form-check-label" for="isPercentageDeduction">
                  Percentage Based
                </label>
              </div>
            </div>

            <div class="mb-3" v-if="componentForm.is_percentage">
              <label for="percentageValueDeduction" class="form-label">Percentage (%) <span class="text-danger">*</span></label>
              <input
                  type="number"
                  class="form-control"
                  id="percentageValueDeduction"
                  v-model="componentForm.percentage"
                  min="0"
                  max="100"
                  step="0.01"
                  placeholder="e.g. 5.0"
                  required
              >
            </div>

            <div class="mb-3" v-else>
              <label for="amountValueDeduction" class="form-label">Amount <span class="text-danger">*</span></label>
              <input
                  type="number"
                  class="form-control"
                  id="amountValueDeduction"
                  v-model="componentForm.amount"
                  min="0"
                  step="0.01"
                  placeholder="e.g. 1000"
                  required
              >
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModalFromEvent($event)">Cancel</button>
          <button
              type="button"
              class="btn btn-primary"
              @click="saveComponentToStructure('deduction')"
              :disabled="!isComponentFormValid || submitLoading"
          >
            <span v-if="submitLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Add Deduction
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Add Benefit to Structure Modal -->
  <div class="modal fade payroll-setup-modal" id="addBenefitModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Benefit to {{ currentStructureName }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeModalFromEvent($event)" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="loadingBenefitTypes" class="text-center py-4">
            <div class="spinner-border text-primary me-2" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">Loading benefits...</p>
          </div>
          <div v-else>
            <div v-if="availableBenefits.length === 0" class="alert alert-info">
              <i class="mdi mdi-information-outline me-2"></i>
              No benefits available. Please create benefits first.
            </div>

            <div v-else class="mb-3">
              <label for="benefitType" class="form-label">Benefit <span class="text-danger">*</span></label>
              <select
                  id="benefitType"
                  class="form-select"
                  v-model="componentForm.component_id"
                  required
              >
                <option value="">Select Benefit</option>
                <option
                    v-for="benefit in availableBenefits"
                    :key="benefit.id"
                    :value="benefit.id"
                >
                  {{ benefit.benefit_name }}
                </option>
              </select>
            </div>

            <div v-if="selectedBenefit" class="card bg-light mt-3">
              <div class="card-body p-3">
                <h6 class="card-title">Benefit Details</h6>
                <p class="card-text mb-1"><small>Description: {{ selectedBenefit.description || 'No description' }}</small></p>
                <p class="card-text mb-0"><small>Monetary Value: {{ selectedBenefit.monetary_value ? formatCurrency(selectedBenefit.monetary_value) : 'N/A' }}</small></p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModalFromEvent($event)">Cancel</button>
          <button
              type="button"
              class="btn btn-primary"
              @click="saveComponentToStructure('benefit')"
              :disabled="!availableBenefits.length || !componentForm.component_id || submitLoading"
          >
            <span v-if="submitLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Add Benefit
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Create Benefit Modal -->
  <div class="modal fade payroll-setup-modal" id="createBenefitModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Create New Benefit</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeModalFromEvent($event)" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="saveBenefit">
            <div class="mb-3">
              <label for="benefitName" class="form-label">Benefit Name <span class="text-danger">*</span></label>
              <input
                  type="text"
                  class="form-control"
                  id="benefitName"
                  v-model="benefitForm.benefit_name"
                  required
                  placeholder="e.g. Medical Insurance, Company Car"
              >
            </div>

            <div class="mb-3">
              <label for="benefitDescription" class="form-label">Description</label>
              <textarea
                  class="form-control"
                  id="benefitDescription"
                  v-model="benefitForm.description"
                  rows="3"
                  placeholder="Describe the benefit"
              ></textarea>
            </div>

            <div class="mb-3">
              <label for="monetaryValue" class="form-label">Monetary Value (optional)</label>
              <input
                  type="number"
                  class="form-control"
                  id="monetaryValue"
                  v-model="benefitForm.monetary_value"
                  min="0"
                  step="0.01"
                  placeholder="e.g. 15000"
              >
              <small class="text-muted">Estimated monetary value of this benefit, if applicable.</small>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModalFromEvent($event)">Cancel</button>
          <button
              type="button"
              class="btn btn-primary"
              @click="saveBenefit"
              :disabled="!isBenefitFormValid || submitLoading"
          >
            <span v-if="submitLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Create Benefit
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>
  </Teleport>
</template>

<script>
/* eslint-disable */
import * as bootstrap from "bootstrap";
import { authUrl, execute } from "@/api";

export default {
  name: 'SalaryStructureManagement',
  data() {
    return {
      loading: false,
      submitLoading: false,
      salaryStructures: [],
      departments: [],
      isEditing: false,
      currentId: null,
      currentStructureName: '',
      structureForm: {
        structure_name: '',
        is_active: true,
        description: '',
        departments: []
      },

      // Linked grades
      loadingGrades: false,
      linkedGrades: [],

      // Available grades for linking
      loadingAvailableGrades: false,
      availableGrades: [],
      filteredAvailableGrades: [],
      gradeSearchKeyword: '',
      selectedGradesToLink: [],
      selectAllGrades: false,

      // Components
      loadingComponents: false,
      structureAllowances: [],
      structureDeductions: [],
      structureBenefits: [],

      modal: null,
      formModal: null,
      linkedGradesModal: null,
      linkGradesModal: null,
      componentsModal: null,

      // Component modals
      addAllowanceModal: null,
      addDeductionModal: null,
      addBenefitModal: null,
      createBenefitModal: null,

      // Available component types
      availableAllowanceTypes: [],
      availableDeductionTypes: [],
      availableBenefits: [],

      // Loading states
      loadingAllowanceTypes: false,
      loadingDeductionTypes: false,
      loadingBenefitTypes: false,

      // Component form
      componentForm: {
        component_id: '',
        is_percentage: false,
        amount: null,
        percentage: null
      },

      // Benefit form
      benefitForm: {
        benefit_name: '',
        description: '',
        monetary_value: null
      }
    };
  },
  computed: {
    isActiveBoolean: {
      get() {
        return this.structureForm.is_active === "1"; // Convert to boolean
      },
      set(value) {
        this.structureForm.is_active = value ? "1" : "0"; // Convert back to string
      }
    },
    isFormValid() {
      return this.structureForm.structure_name !== '';
    },
    isComponentFormValid() {
      if (!this.componentForm.component_id) return false;

      if (this.componentForm.is_percentage) {
        return this.componentForm.percentage !== null && this.componentForm.percentage > 0;
      } else {
        return this.componentForm.amount !== null && this.componentForm.amount > 0;
      }
    },
    isBenefitFormValid() {
      return this.benefitForm.benefit_name.trim() !== '';
    },
    selectedBenefit() {
      if (!this.componentForm.component_id) return null;

      return this.availableBenefits.find(benefit =>
          benefit.id == this.componentForm.component_id
      );
    }
  },
  mounted() {
    this.initModals();
  },
  methods: {
    initModals() {
      this.$nextTick(() => {
        // Initialize the main modal
        this.modal = new bootstrap.Modal(document.getElementById('salaryStructureManagementModal'));

        // Initialize form modal
        this.formModal = new bootstrap.Modal(document.getElementById('salaryStructureFormModal'));

        // Initialize linked grades modal
        this.linkedGradesModal = new bootstrap.Modal(document.getElementById('linkedGradesModal'));

        // Initialize link grades modal
        this.linkGradesModal = new bootstrap.Modal(document.getElementById('linkGradesModal'));

        // Initialize components modal
        this.componentsModal = new bootstrap.Modal(document.getElementById('salaryComponentsModal'));

        // Listen for modal hidden events to reset form
        document.getElementById('salaryStructureFormModal').addEventListener('hidden.bs.modal', this.resetForm);
        document.getElementById('linkGradesModal').addEventListener('hidden.bs.modal', this.resetLinkGradesForm);
      });
      // Initialize component modals
      this.addAllowanceModal = new bootstrap.Modal(document.getElementById('addAllowanceModal'));
      this.addDeductionModal = new bootstrap.Modal(document.getElementById('addDeductionModal'));
      this.addBenefitModal = new bootstrap.Modal(document.getElementById('addBenefitModal'));
      this.createBenefitModal = new bootstrap.Modal(document.getElementById('createBenefitModal'));

      // Listen for modal hidden events to reset forms
      document.getElementById('addAllowanceModal').addEventListener('hidden.bs.modal', this.resetComponentForm);
      document.getElementById('addDeductionModal').addEventListener('hidden.bs.modal', this.resetComponentForm);
      document.getElementById('addBenefitModal').addEventListener('hidden.bs.modal', this.resetComponentForm);
      document.getElementById('createBenefitModal').addEventListener('hidden.bs.modal', this.resetBenefitForm);

    },
    showModal() {
      if (this.modal) {
        this.loadSalaryStructures();
        this.loadDepartments();
        this.modal.show();
      } else {
        this.initModals();
        setTimeout(() => {
          if (this.modal) {
            this.loadSalaryStructures();
            this.loadDepartments();
            this.modal.show();
          }
        }, 100);
      }
    },
    hideModal() {
      if (this.modal) {
        this.modal.hide();
      }
    },
    showAddModal() {
      this.isEditing = false;
      this.currentId = null;
      this.resetForm();
      if (this.formModal) {
        this.formModal.show();
      }
    },
    showEditModal() {
      if (this.formModal) {
        this.formModal.show();
      }
    },
    hideFormModal() {
      if (this.formModal) {
        this.formModal.hide();
      }
    },
    resetForm() {
      this.structureForm = {
        structure_name: '',
        is_active: true,
        description: '',
        departments: []
      };
      this.submitLoading = false;
    },
    resetLinkGradesForm() {
      this.gradeSearchKeyword = '';
      this.selectedGradesToLink = [];
      this.selectAllGrades = false;
    },
    // API Calls
    loadSalaryStructures() {
      this.loading = true;

      const data = new FormData();
      data.append("function", "getSalaryStructures");

      execute(data, authUrl)
          .then((res) => {
            this.loading = false;

            if (res.data.success) {
              this.salaryStructures = res.data.data.salaryStructures || [];
            } else {
              console.error("Error fetching salary structures:", res.data.message);
              alert(res.data.message || "Failed to load salary structures");
            }
          })
          .catch((error) => {
            this.loading = false;
            console.error("API Error:", error);
            alert("An error occurred while loading salary structures");
          });
    },
    loadDepartments() {
      const data = new FormData();
      data.append("function", "getDepartments");

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.departments = res.data.data.departments || [];
            } else {
              console.error("Error fetching departments:", res.data.message);
            }
          })
          .catch((error) => {
            console.error("API Error:", error);
          });
    },
    editStructure(structure) {
      this.isEditing = true;
      this.currentId = structure.id;

      // Copy structure data to form
      this.structureForm = {
        structure_name: structure.structure_name,
        is_active: structure.is_active,
        description: structure.description || '',
        departments: structure.departments || []
      };

      this.showEditModal();
    },
    deleteStructure(id) {
      if (!confirm("Are you sure you want to delete this salary structure? This may affect employee salaries.")) {
        return;
      }

      this.loading = true;

      const data = new FormData();
      data.append("function", "deleteSalaryStructure");
      data.append("id", id);

      execute(data, authUrl)
          .then((res) => {
            this.loading = false;

            if (res.data.success) {
              alert(res.data.message || "Salary structure deleted successfully");
              this.loadSalaryStructures();
            } else {
              alert(res.data.message || "Failed to delete salary structure");
            }
          })
          .catch((error) => {
            this.loading = false;
            console.error("API Error:", error);
            alert("An error occurred while deleting salary structure");
          });
    },
    saveStructure() {
      if (!this.isFormValid) {
        alert("Please fill all required fields");
        return;
      }

      this.submitLoading = true;

      const data = new FormData();
      data.append("function", this.isEditing ? "updateSalaryStructure" : "createSalaryStructure");

      if (this.isEditing) {
        data.append("id", this.currentId);
      }

      data.append("structure_name", this.structureForm.structure_name);
      data.append("is_active", this.isActiveBoolean? 1 : 0);

      if (this.structureForm.description) {
        data.append("description", this.structureForm.description);
      }

      if (this.structureForm.departments.length > 0) {
        data.append("departments", JSON.stringify(this.structureForm.departments));
      }

      execute(data, authUrl)
          .then((res) => {
            this.submitLoading = false;

            if (res.data.success) {
              alert(res.data.message || (this.isEditing ? "Salary structure updated successfully" : "Salary structure created successfully"));
              this.hideFormModal();
              this.loadSalaryStructures();
            } else {
              alert(res.data.message || "Failed to save salary structure");
            }
          })
          .catch((error) => {
            this.submitLoading = false;
            console.error("API Error:", error);
            alert("An error occurred while saving salary structure");
          });
    },
    setActiveStructure(id) {
      if (!confirm("Are you sure you want to set this as the active salary structure?")) {
        return;
      }

      this.loading = true;

      const data = new FormData();
      data.append("function", "setActiveSalaryStructure");
      data.append("id", id);

      execute(data, authUrl)
          .then((res) => {
            this.loading = false;

            if (res.data.success) {
              alert(res.data.message || "Salary structure set as active successfully");
              this.loadSalaryStructures();
            } else {
              alert(res.data.message || "Failed to set salary structure as active");
            }
          })
          .catch((error) => {
            this.loading = false;
            console.error("API Error:", error);
            alert("An error occurred while setting active salary structure");
          });
    },
    // Pay Grade Management
    viewLinkedGrades(structure) {
      this.currentId = structure.id;
      this.currentStructureName = structure.structure_name;
      this.loadLinkedGrades(structure.id);

      if (this.linkedGradesModal) {
        this.linkedGradesModal.show();
      }
    },
    loadLinkedGrades(structureId) {
      this.loadingGrades = true;

      const data = new FormData();
      data.append("function", "getLinkedPayGrades");
      data.append("structure_id", structureId);

      execute(data, authUrl)
          .then((res) => {
            this.loadingGrades = false;

            if (res.data.success) {
              this.linkedGrades = res.data.data.payGrades || [];
            } else {
              console.error("Error fetching linked pay grades:", res.data.message);
              alert(res.data.message || "Failed to load linked pay grades");
            }
          })
          .catch((error) => {
            this.loadingGrades = false;
            console.error("API Error:", error);
            alert("An error occurred while loading linked pay grades");
          });
    },
    linkNewGrades() {
      // Load available grades first
      this.loadAvailableGrades();

      // Hide linked grades modal and show link grades modal
      const linkedModal = bootstrap.Modal.getInstance(document.getElementById('linkedGradesModal'));
      if (linkedModal) {
        linkedModal.hide();
      }

      setTimeout(() => {
        if (this.linkGradesModal) {
          this.linkGradesModal.show();
        }
      }, 500);
    },
    loadAvailableGrades() {
      this.loadingAvailableGrades = true;

      const data = new FormData();
      data.append("function", "getAvailablePayGrades");
      data.append("structure_id", this.currentId);

      execute(data, authUrl)
          .then((res) => {
            this.loadingAvailableGrades = false;

            if (res.data.success) {
              this.availableGrades = res.data.data.payGrades || [];
              this.filteredAvailableGrades = [...this.availableGrades];
            } else {
              console.error("Error fetching available pay grades:", res.data.message);
              alert(res.data.message || "Failed to load available pay grades");
            }
          })
          .catch((error) => {
            this.loadingAvailableGrades = false;
            console.error("API Error:", error);
            alert("An error occurred while loading available pay grades");
          });
    },
    searchGrades() {
      if (!this.gradeSearchKeyword.trim()) {
        this.filteredAvailableGrades = [...this.availableGrades];
      } else {
        const keyword = this.gradeSearchKeyword.toLowerCase();
        this.filteredAvailableGrades = this.availableGrades.filter(
            grade => grade.grade_name.toLowerCase().includes(keyword)
        );
      }
    },
    toggleSelectAllGrades() {
      if (this.selectAllGrades) {
        this.selectedGradesToLink = this.filteredAvailableGrades.map(grade => grade.id);
      } else {
        this.selectedGradesToLink = [];
      }
    },
    linkSelectedGrades() {
      if (!this.selectedGradesToLink.length) {
        alert("Please select at least one pay grade to link");
        return;
      }

      this.submitLoading = true;

      const data = new FormData();
      data.append("function", "linkPayGradesToStructure");
      data.append("structure_id", this.currentId);
      data.append("grade_ids", JSON.stringify(this.selectedGradesToLink));

      execute(data, authUrl)
          .then((res) => {
            this.submitLoading = false;

            if (res.data.success) {
              alert(res.data.message || "Pay grades linked successfully");

              // Hide the link grades modal
              const linkModal = bootstrap.Modal.getInstance(document.getElementById('linkGradesModal'));
              if (linkModal) {
                linkModal.hide();
              }

              // Reload linked grades and show linked grades modal
              this.loadLinkedGrades(this.currentId);
              setTimeout(() => {
                if (this.linkedGradesModal) {
                  this.linkedGradesModal.show();
                }
              }, 500);
            } else {
              alert(res.data.message || "Failed to link pay grades");
            }
          })
          .catch((error) => {
            this.submitLoading = false;
            console.error("API Error:", error);
            alert("An error occurred while linking pay grades");
          });
    },
    unlinkGrade(gradeId) {
      if (!confirm("Are you sure you want to unlink this pay grade from the salary structure?")) {
        return;
      }

      this.loadingGrades = true;

      const data = new FormData();
      data.append("function", "unlinkPayGradeFromStructure");
      data.append("structure_id", this.currentId);
      data.append("grade_id", gradeId);

      execute(data, authUrl)
          .then((res) => {
            this.loadingGrades = false;

            if (res.data.success) {
              alert(res.data.message || "Pay grade unlinked successfully");
              this.loadLinkedGrades(this.currentId);
            } else {
              alert(res.data.message || "Failed to unlink pay grade");
            }
          })
          .catch((error) => {
            this.loadingGrades = false;
            console.error("API Error:", error);
            alert("An error occurred while unlinking pay grade");
          });
    },

    // Salary Components Management
    manageSalaryComponents(structure) {
      this.currentId = structure.id;
      this.currentStructureName = structure.structure_name;
      this.loadSalaryComponents(structure.id);

      if (this.componentsModal) {
        this.componentsModal.show();
      }
    },
    loadSalaryComponents(structureId) {
      this.loadingComponents = true;

      const data = new FormData();
      data.append("function", "getSalaryStructureComponents");
      data.append("structure_id", structureId);

      execute(data, authUrl)
          .then((res) => {
            this.loadingComponents = false;

            if (res.data.success) {
              const components = res.data.data;
              this.structureAllowances = components.allowances || [];
              this.structureDeductions = components.deductions || [];
              this.structureBenefits = components.benefits || [];
            } else {
              console.error("Error fetching salary components:", res.data.message);
              alert(res.data.message || "Failed to load salary components");
            }
          })
          .catch((error) => {
            this.loadingComponents = false;
            console.error("API Error:", error);
            alert("An error occurred while loading salary components");
          });
    },
    removeComponentFromStructure(componentId, type) {
      if (!confirm(`Are you sure you want to remove this ${type} from the salary structure?`)) {
        return;
      }

      this.loadingComponents = true;

      const data = new FormData();
      data.append("function", "removeComponentFromSalaryStructure");
      data.append("structure_id", this.currentId);
      data.append("component_id", componentId);
      data.append("component_type", type);

      execute(data, authUrl)
          .then((res) => {
            this.loadingComponents = false;

            if (res.data.success) {
              alert(res.data.message || `${type.charAt(0).toUpperCase() + type.slice(1)} removed successfully`);
              this.loadSalaryComponents(this.currentId);
            } else {
              alert(res.data.message || `Failed to remove ${type}`);
            }
          })
          .catch((error) => {
            this.loadingComponents = false;
            console.error("API Error:", error);
            alert(`An error occurred while removing ${type}`);
          });
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(value || 0);
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return new Date(dateString).toLocaleDateString('en-US', options);
    },

    // Reset forms
    resetComponentForm() {
      this.componentForm = {
        component_id: '',
        is_percentage: false,
        amount: null,
        percentage: null
      };
      this.submitLoading = false;
    },
    resetBenefitForm() {
      this.benefitForm = {
        benefit_name: '',
        description: '',
        monetary_value: null
      };
      this.submitLoading = false;
    },

    // Show component modals
    addAllowanceToStructure() {
      this.loadAllowanceTypes();
      this.resetComponentForm();

      if (this.addAllowanceModal) {
        this.addAllowanceModal.show();
      }
    },
    addDeductionToStructure() {
      this.loadDeductionTypes();
      this.resetComponentForm();

      if (this.addDeductionModal) {
        this.addDeductionModal.show();
      }
    },
    addBenefitToStructure() {
      this.loadBenefits();
      this.resetComponentForm();

      if (this.addBenefitModal) {
        this.addBenefitModal.show();
      }
    },

    showCreateBenefitModal() {
      this.resetBenefitForm();

      // Hide benefit modal first
      if (this.addBenefitModal) {
        this.addBenefitModal.hide();
      }

      setTimeout(() => {
        if (this.createBenefitModal) {
          this.createBenefitModal.show();
        }
      }, 500);
    },

    // Load component types
    loadAllowanceTypes() {
      this.loadingAllowanceTypes = true;

      const data = new FormData();
      data.append("function", "getAllowanceTypes");

      execute(data, authUrl)
          .then((res) => {
            this.loadingAllowanceTypes = false;

            if (res.data.success) {
              this.availableAllowanceTypes = res.data.data.allowanceTypes || [];

              // Filter out allowances already added to the structure
              if (this.structureAllowances && this.structureAllowances.length > 0) {
                const existingIds = this.structureAllowances.map(a => a.allowance_type_id);
                this.availableAllowanceTypes = this.availableAllowanceTypes.filter(
                    at => !existingIds.includes(at.id)
                );
              }
            } else {
              console.error("Error fetching allowance types:", res.data.message);
              alert(res.data.message || "Failed to load allowance types");
            }
          })
          .catch((error) => {
            this.loadingAllowanceTypes = false;
            console.error("API Error:", error);
            alert("An error occurred while loading allowance types");
          });
    },
    loadDeductionTypes() {
      this.loadingDeductionTypes = true;

      const data = new FormData();
      data.append("function", "getDeductionTypes");

      execute(data, authUrl)
          .then((res) => {
            this.loadingDeductionTypes = false;

            if (res.data.success) {
              this.availableDeductionTypes = res.data.data.deductionTypes || [];

              // Filter out deductions already added to the structure
              if (this.structureDeductions && this.structureDeductions.length > 0) {
                const existingIds = this.structureDeductions.map(d => d.deduction_type_id);
                this.availableDeductionTypes = this.availableDeductionTypes.filter(
                    dt => !existingIds.includes(dt.id)
                );
              }
            } else {
              console.error("Error fetching deduction types:", res.data.message);
              alert(res.data.message || "Failed to load deduction types");
            }
          })
          .catch((error) => {
            this.loadingDeductionTypes = false;
            console.error("API Error:", error);
            alert("An error occurred while loading deduction types");
          });
    },
    loadBenefits() {
      this.loadingBenefitTypes = true;

      const data = new FormData();
      data.append("function", "getBenefits");

      execute(data, authUrl)
          .then((res) => {
            this.loadingBenefitTypes = false;

            if (res.data.success) {
              this.availableBenefits = res.data.data.benefits || [];

              // Filter out benefits already added to the structure
              if (this.structureBenefits && this.structureBenefits.length > 0) {
                const existingIds = this.structureBenefits.map(b => b.benefit_id);
                this.availableBenefits = this.availableBenefits.filter(
                    bt => !existingIds.includes(bt.id)
                );
              }
            } else {
              console.error("Error fetching benefits:", res.data.message);
              alert(res.data.message || "Failed to load benefits");
            }
          })
          .catch((error) => {
            this.loadingBenefitTypes = false;
            console.error("API Error:", error);
            alert("An error occurred while loading benefits");
          });
    },

    // Save operations
    saveComponentToStructure(componentType) {
      if (componentType === 'benefit' && !this.componentForm.component_id) {
        alert("Please select a benefit");
        return;
      } else if ((componentType === 'allowance' || componentType === 'deduction') && !this.isComponentFormValid) {
        alert("Please fill all required fields");
        return;
      }

      this.submitLoading = true;

      const data = new FormData();
      data.append("function", "addComponentToSalaryStructure");
      data.append("structure_id", this.currentId);
      data.append("component_type", componentType);
      data.append("component_id", this.componentForm.component_id);

      if (componentType !== 'benefit') {
        data.append("is_percentage", this.componentForm.is_percentage ? 1 : 0);

        if (this.componentForm.is_percentage) {
          data.append("percentage", this.componentForm.percentage);
        } else {
          data.append("amount", this.componentForm.amount);
        }
      }

      execute(data, authUrl)
          .then((res) => {
            this.submitLoading = false;

            if (res.data.success) {
              alert(res.data.message || `${componentType.charAt(0).toUpperCase() + componentType.slice(1)} added successfully`);

              // Close the modal
              if (componentType === 'allowance' && this.addAllowanceModal) {
                this.addAllowanceModal.hide();
              } else if (componentType === 'deduction' && this.addDeductionModal) {
                this.addDeductionModal.hide();
              } else if (componentType === 'benefit' && this.addBenefitModal) {
                this.addBenefitModal.hide();
              }

              // Reload components
              this.loadSalaryComponents(this.currentId);
            } else {
              alert(res.data.message || `Failed to add ${componentType}`);
            }
          })
          .catch((error) => {
            this.submitLoading = false;
            console.error("API Error:", error);
            alert(`An error occurred while adding ${componentType}`);
          });
    },
    saveBenefit() {
      if (!this.isBenefitFormValid) {
        alert("Please provide a benefit name");
        return;
      }

      this.submitLoading = true;

      const data = new FormData();
      data.append("function", "createBenefit");
      data.append("benefit_name", this.benefitForm.benefit_name);

      if (this.benefitForm.description) {
        data.append("description", this.benefitForm.description);
      }

      if (this.benefitForm.monetary_value) {
        data.append("monetary_value", this.benefitForm.monetary_value);
      }

      execute(data, authUrl)
          .then((res) => {
            this.submitLoading = false;

            if (res.data.success) {
              alert(res.data.message || "Benefit created successfully");

              // Close the modal
              if (this.createBenefitModal) {
                this.createBenefitModal.hide();
              }

              // Reload benefits and show the add benefit modal again
              this.loadBenefits();
              setTimeout(() => {
                if (this.addBenefitModal) {
                  this.addBenefitModal.show();
                }
              }, 500);
            } else {
              alert(res.data.message || "Failed to create benefit");
            }
          })
          .catch((error) => {
            this.submitLoading = false;
            console.error("API Error:", error);
            alert("An error occurred while creating benefit");
          });
    }


  }
};
</script>

<style scoped>
.form-check {
  margin-bottom: 0.5rem;
}

.alert {
  margin-top: 1rem;
}

.card {
  transition: transform 0.2s;
}

.card:hover {
  transform: translateY(-3px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.nav-tabs .nav-link {
  font-weight: 500;
}

.nav-tabs .nav-link.active {
  border-bottom: 2px solid #4e73df;
}
</style>